import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { completeGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || '';
    const sessionId = new URLSearchParams(hash.replace('#', '')).get('session_id');
    if (!sessionId) {
      navigate('/sign-in', { replace: true });
      return;
    }
    completeGoogleSession(sessionId)
      .then(() => {
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/app', { replace: true });
      })
      .catch(() => navigate('/sign-in', { replace: true }));
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0c] flex items-center justify-center" data-testid="auth-callback-loading">
      <Loader2 className="w-6 h-6 text-[#ea9a6f] animate-spin" />
    </div>
  );
}
